const SkeletonCellRenderer = () => {
  return <span className="skeleton skeleton-text skeleton-pulse" />;
};

export default SkeletonCellRenderer;
